var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 49.8398 49.8398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "M logo red"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Logo Background",
    width: 49.8398,
    height: 49.8398,
    rx: 3.48792,
    fill: "var(--fill-0, #DB0007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.6536 10.0663C29.621 10.0358 26.8761 14.0499 25.0434 20.3454C23.3408 14.0144 20.6772 9.94592 17.6446 9.91544C12.3165 9.86189 7.85871 23.2592 7.6921 39.8365L11.9813 39.8796C12.1361 24.4852 14.6608 12.0303 17.623 12.0601C20.5853 12.0898 22.8688 23.6346 22.726 37.8461L27.0152 37.8892C27.1581 23.6777 29.6731 12.1812 32.6354 12.2109C35.5943 12.2407 37.8715 24.7439 37.7168 40.1382L42.0061 40.1813C42.1693 23.604 37.985 10.1199 32.6536 10.0663Z",
    fill: "var(--fill-0, #FFBC0D)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogoRed);
export default __webpack_public_path__ + "static/media/m-logo-red.42df2f5039b050a4a1db23d16f0c79ff.svg";
export { ForwardRef as ReactComponent };